import { createContext, useContext } from "react";
import { IntegrationDefinition } from "@/types/breeze/Integration";

// Owned by ConfigDialog; consumed by provider extensions under providers/{name}/.
export interface OAuthFormState {
  definition: IntegrationDefinition;

  nativeAudiencesText: string;
  setNativeAudiencesText: (s: string) => void;

  webClientId: string;
  setWebClientId: (s: string) => void;

  webClientSecret: string;
  setWebClientSecret: (s: string) => void;

  hasExistingWebSecret: boolean;

  appleWebMethod: "p8" | "jwt";
  setAppleWebMethod: (m: "p8" | "jwt") => void;

  applePrivateKey: string;
  setApplePrivateKey: (s: string) => void;

  hasExistingApplePrivateKey: boolean;

  appleKeyId: string;
  setAppleKeyId: (s: string) => void;

  appleTeamId: string;
  setAppleTeamId: (s: string) => void;

  allowMissingEmail: boolean;
  setAllowMissingEmail: (b: boolean) => void;
}

const OAuthFormContext = createContext<OAuthFormState | null>(null);

export function useOAuthForm(): OAuthFormState {
  const ctx = useContext(OAuthFormContext);
  if (!ctx) {
    throw new Error(
      "useOAuthForm must be used inside an OAuthFormProvider",
    );
  }
  return ctx;
}

export const OAuthFormProvider = OAuthFormContext.Provider;
